import React from 'react';
import { ProFormSelect } from '@ant-design/pro-form';
import { useQuery, gql } from '@apollo/client';
import { PLACEHOLDER } from 'constants/form';

const GET_FACULTIES = gql`
  query GET_FACULTIES($ids: [ID!], $state: State) {
    faculties(ids: $ids, state: $state) {
      id
      name
      abbreviation
    }
  }
`;

const SelectFaculty = ({ ...props }) => {
  const { data, loading } = useQuery(GET_FACULTIES, {
    variables: { state: 'ACTIVE' },
  });
  const options = loading
    ? []
    : data.faculties.map(({ id, name, abbreviation }) => ({
        value: id,
        label: `${abbreviation} - ${name}`,
      }));
  return (
    <ProFormSelect
      showSearch
      fieldProps={{ loading }}
      width="xl"
      name="faculty"
      label="Faculty"
      placeholder={PLACEHOLDER.PLEASE_SELECT}
      rules={
        props?.disabled
          ? []
          : [
              {
                required: true,
                message: 'Please select faculty!',
              },
            ]
      }
      options={options}
      {...props}
    />
  );
};

export default SelectFaculty;
